import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../api";
import { useLang } from "../i18n";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const { lang } = useLang();
  const bm = lang === "bm";
  const navigate = useNavigate();
  const [state, setState] = useState("polling");
  const attempts = useRef(0);
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) {
      setState("failed");
      return;
    }
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          setState("paid");
          return;
        }
      } catch {}
      attempts.current += 1;
      if (attempts.current >= 25) setState("failed");
      else setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <Card className="max-w-md w-full" data-testid="payment-success-page">
        <CardContent className="pt-8 pb-8 text-center space-y-4">
          {state === "polling" && (
            <>
              <Loader2 className="w-12 h-12 mx-auto text-blue-700 animate-spin" />
              <h1 className="text-xl font-bold">{bm ? "Mengesahkan pembayaran..." : "Confirming your payment..."}</h1>
              <p className="text-sm text-slate-500">{bm ? "Sila tunggu sebentar." : "Please hold on a moment."}</p>
            </>
          )}
          {state === "paid" && (
            <>
              <CheckCircle2 className="w-14 h-14 mx-auto text-emerald-600" />
              <h1 className="text-2xl font-bold" data-testid="payment-success-title">
                {bm ? "Pembayaran Berjaya!" : "Payment Successful!"}
              </h1>
              <p className="text-sm text-slate-600">
                {bm
                  ? "Langganan anda kini aktif. Plan anda telah dikemas kini."
                  : "Your subscription is now active. Your plan has been upgraded."}
              </p>
              <Button data-testid="payment-success-continue" className="bg-blue-800 hover:bg-blue-900" onClick={() => navigate("/settings")}>
                {bm ? "Kembali ke Tetapan" : "Back to Settings"}
              </Button>
            </>
          )}
          {state === "failed" && (
            <>
              <XCircle className="w-14 h-14 mx-auto text-rose-600" />
              <h1 className="text-xl font-bold">{bm ? "Pembayaran belum selesai" : "Payment not completed"}</h1>
              <p className="text-sm text-slate-600">
                {bm ? "Jika anda telah membayar, status akan dikemas kini sebentar lagi." : "If you completed payment, the status will update shortly."}
              </p>
              <Button variant="outline" onClick={() => navigate("/settings")}>{bm ? "Kembali" : "Go Back"}</Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
